import { SLOT_HOURS } from './stats';
import type { Shift, Staff } from './types';

// A helper's effective hourly rate — their custom rate, or the shared minimum
// wage when they're on it (the manage-staff lever). null = on minimum wage.
export function effectiveRate(staff: Pick<Staff, 'rate'>, minimumWage: number): number {
  return staff.rate ?? minimumWage;
}

export interface PayRow {
  staff: Staff;
  shifts: number; // filled shifts in the week
  hours: number; // shifts × 3h
  rate: number; // effective €/hr
  wage: number; // hours × rate
  paid: boolean;
}

// One helper's pay for a Fri–Thu week: count their filled shifts on the week's
// dates, × 3h = hours, × effective rate = wage. Rounded to cents.
export function weekPayRow(
  staff: Staff,
  weekDates: string[],
  shifts: Shift[],
  minimumWage: number,
  paid: boolean,
): PayRow {
  const dates = new Set(weekDates);
  const count = shifts.filter((s) => s.staffId === staff.id && dates.has(s.date)).length;
  const hours = count * SLOT_HOURS;
  const rate = effectiveRate(staff, minimumWage);
  return { staff, shifts: count, hours, rate, wage: Math.round(hours * rate * 100) / 100, paid };
}

// Unpaid wages across a set of pay rows — the period's Outstanding total.
export function outstanding(rows: PayRow[]): number {
  return Math.round(rows.filter((r) => !r.paid).reduce((a, r) => a + r.wage, 0) * 100) / 100;
}
